module.exports = __webpack_public_path__ + "assets/img/28_1078_big.5c4255cc.jpg";